/* eslint-disable no-template-curly-in-string */
/* eslint-disable no-unused-vars */
import * as React from 'react';
import Image from 'next/image';
import dynamic from 'next/dynamic';
import {
  Box,
  Avatar,
  Stack,
  Typography,
  Card,
  Divider,
  ButtonBase,
} from '@mui/material';
import { styled } from '@mui/system';
import { tokens } from '../../../../tokens';

const CVVIButton = styled(ButtonBase)(({ theme }) => ({
  position: 'relative',
  height: 200,
  [theme.breakpoints.down('sm')]: {
    width: '100% !important', // Overrides inline-style
    height: 185,
  },
  '&:hover, &.Mui-focusVisible': {
    zIndex: 99,
    '& .MuiImageBackdrop-root': {
      opacity: 0.15,
      backgroundColor: tokens.token_apple_grey,
    },
    '& .MuiImageMarked-root': {
      opacity: 0,
    },
    '& .MuiTypography-root': {
      border: '4px solid currentColor',
    },
  },
}));

const CVVIBackdrop = styled('span')(({ theme }) => ({
  position: 'absolute',
  left: 0,
  right: 0,
  top: 0,
  bottom: 0,
  backgroundColor: tokens.token_surface,
  opacity: 0,
  transition: theme.transitions.create('opacity'),
}));

const LogoMarked = styled(Box)(() => ({
  height: '26px',
  width: '26px',

  // backgroundColor: tokens.token_black,
  position: 'absolute',
  top: 5,
  right: 'calc(92% - 9px)',
  // transition: theme.transitions.create('opacity'),
}));

const NameTypo = styled(Typography)(() => ({
  fontFamily: 'Roboto, Arial,sans-serif',
  fontSize: '.85rem',
  fontWeight: 400,
  color: tokens.token_text_grey_on_white,
  lineHeight: '1.00rem',
  letterSpacing: '.025em',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  textAlign: 'left',
}));

const DataTypo = styled(Typography)(() => ({
  fontFamily: 'Google Sans, Roboto, Arial, sans-serif',
  fontSize: '0.85rem',
  fontWeight: 500,
  lineHeight: '1.00rem',
  letterSpacing: '.025em',
  textAlign: 'left',
  color: tokens.token_typography_regular_emphasized,
}));

const DefTypo = styled(Typography)(() => ({
  fontFamily: 'Roboto, Arial,sans-serif',
  fontSize: '.75rem',
  fontWeight: 400,
  color: tokens.token_text_grey_on_white,
  lineHeight: '1.00rem',
  letterSpacing: '.025em',
  // whiteSpace: 'nowrap',
  // overflow: 'hidden',
  // textOverflow: 'ellipsis',
  textAlign: 'left',
}));
const IndexTypo = styled(Typography)(() => ({
  fontFamily: 'Google Sans, Roboto, Arial, sans-serif',
  fontSize: '0.85rem',
  fontWeight: 500,
  lineHeight: '1.00rem',
  letterSpacing: '.025em',
  textAlign: 'left',
  color: tokens.token_typography_regular_emphasized,
}));
const CVVICard = styled(Card)(() => ({
  border: '1px solid',
  borderColor: tokens.token_hairline,
  borderRadius: '12px',
  width: '300px',
  height: '185px',
  margin: 2,
  display: 'flex',
  flexWrap: 'wrap',
  // paddingRight: '16px',
  // paddingLeft: '16px',
  // paddingTop: '4px',
  // paddingBottom: '4px',
  backgroundColor: tokens.token_surface,
  // '&:hover': {
  //   boxShadow: '0 0 5px #9aa0a6',
  // },
}));

const DefCard = styled(Box)(() => ({
  border: '1px solid',
  borderColor: tokens.token_hairline,
  borderRadius: '12px',
  width: '330px',
  height: '185px',
  margin: 2,
  paddingRight: '16px',
  paddingLeft: '16px',
  paddingTop: '16px',
  paddingBottom: '4px',
  backgroundColor: tokens.token_surface,
  // '&:hover': {
  //   boxShadow: '0 0 5px #9aa0a6',
  // },
}));
const ReactSpeedometer = dynamic(() => import('react-d3-speedometer'), {
  ssr: false,
});
export default function ExchangeCVVI({ setSelectedInnerCvvi }) {
  return (
    <Stack direction="row" spacing={1}>
      <CVVICard variant="outlined" sx={{}}>
        <CVVIButton
          onClick={() => {
            setSelectedInnerCvvi('Centralized Exchanges');
          }}
          focusRipple
          style={{
            width: 300,
          }}
        >
          <CVVIBackdrop className="MuiImageBackdrop-root" />
          <ReactSpeedometer
            fluidWidth
            // width={300}
            // height={185}
            minValue={0}
            maxValue={100}
            value={67}
            valueFormat="d"
            // customSegmentStops={[0, 20, 40, 60, 80, 100]}
            needleColor="0A2B3B"
            needleHeightRatio={0.6}
            //   segmentValueFormatter={segmentValueFormatter}
            segmentColors={[
              '#fff2e8',
              '#ffdabf',
              '#ffb987',
              '#ff9b54',
              '#FF7E24',
            ]}
            color="#5F6368"
            valueTextFontSize="0.75rem"
            currentValueText="Crypto CEX Vice and Virtue Index™: ${value}"
            // paddingHorizontal={34}
            // paddingVertical={34}
            customSegmentLabels={[
              {
                text: 'Virtue',
                position: 'INSIDE',
                color: tokens.palette_primary,
                fontSize: '10px',
              },
              {
                text: 'Benevolence',
                position: 'INSIDE',
                color: tokens.palette_primary,
                fontSize: '10px',
              },
              {
                text: 'Balance',
                position: 'INSIDE',
                color: tokens.palette_primary,
                fontSize: '10px',
              },
              {
                text: 'Malice',
                position: 'INSIDE',
                color: tokens.palette_primary,
                fontSize: '10px',
              },
              {
                text: 'Vice',
                position: 'INSIDE',
                color: tokens.palette_primary,
                fontSize: '10px',
              },
            ]}
          />

          <LogoMarked className="MuiImageMarked-root">
            <Image
              width={24}
              height={24}
              src="/cryptobank64x64_2.png"
              alt="logo"
            />
          </LogoMarked>
        </CVVIButton>
      </CVVICard>
      {/* <DefCard sx={{}}>
        <Stack direction="row" spacing={1} justifyContent="space-between">
          <Stack>
            <NameTypo>1 week ago</NameTypo>
            <DataTypo>Balance</DataTypo>
          </Stack>

          <Avatar
            sx={{ bgcolor: tokens.token_grey_300, width: 28, height: 28 }}
            aria-label="CVVI Value"
          >
            <IndexTypo>55</IndexTypo>
          </Avatar>
        </Stack>
        <Divider sx={{ my: '5px' }} />
        <Stack direction="row" spacing={1} justifyContent="space-between">
          <Stack>
            <NameTypo>1 month ago</NameTypo>
            <DataTypo>Vice</DataTypo>
          </Stack>

          <Avatar
            sx={{
              bgcolor: tokens.token_text_grey_on_grey,
              width: 28,
              height: 28,
            }}
            aria-label="CVVI Value"
          >
            <IndexTypo>87</IndexTypo>
          </Avatar>
        </Stack>
        <Divider sx={{ my: '5px' }} />
        <DefTypo>
          The Crypto Vice & Virtue Index is a way to gauge blockchain security
          and safety and whether users' sentiment corresponds to actual
          blockchain performance.
        </DefTypo>
      </DefCard> */}
    </Stack>
  );
}
